import { render, staticRenderFns } from "./WsCustomerService.vue?vue&type=template&id=316eb376&scoped=true"
import script from "./WsCustomerService.vue?vue&type=script&lang=js"
export * from "./WsCustomerService.vue?vue&type=script&lang=js"
import style0 from "./WsCustomerService.vue?vue&type=style&index=0&id=316eb376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316eb376",
  null
  
)

export default component.exports